import { useQuery } from "@tanstack/react-query";

import type { IWebsiteAnalysisTrafficRequestParams } from "app/pages/website-analysis/TrafficAndEngagement/types";
import WebsiteAnalysisApiService from "app/services/WebsiteAnalysis/WebsitAnalysisApiService";

interface ITotalVisitsResponse {
    Data: Record<
        string,
        {
            TotalVisits: number;
            Change: number;
            ShareOfVisits: number;
        }
    >;
    FromAlternativeSources?: boolean;
}

export const useTotalVisitsData = (
    params: IWebsiteAnalysisTrafficRequestParams,
    controller: string,
    { enabled = true }: { enabled?: boolean } = {},
) => {
    return useQuery<ITotalVisitsResponse>({
        queryKey: ["totalVisitsSingle", params, controller],
        queryFn: () => WebsiteAnalysisApiService.getInstance().getSingleTotalVisitsData(params, controller),
        enabled,
    });
};
